export const APPActions = {
    SET_AUTH_USER: "SET_AUTH_USER",
    LOGOUT: "LOGOUT",
    SET_SELECTED_ESTATE: "SET_SELECTED_ESTATE"
};
